import { down } from 'styled-breakpoints'
import styled from 'styled-components'

export const FaqContainer = styled.div`
  display: block;
  margin: 32px 0px;
`

export const FaqHeader = styled.div`
  font-weight: 700;
  font-size: 24px;
  line-height: 33px;
  color: #131717;
  ${down('md')} {
    margin-top: 20px;
  }
`
export const Faq = styled.div``
export const FaqQuesiton = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 25px;
  font-size: 16px;
  ${down('md')} {
    padding: 10px;
  }
`

export const FaqAnswer = styled.div`
  font-weight: 400;
  font-size: 16px;
  line-height: 26px;
  color: #131717;
  padding: 0px 25px;
  ${down('md')} {
    padding: 0px 10px;
  }
`

export const FaqIcon = styled.div`
  display: flex;
  align-items: center;
`
